/*  Copyright Mihai Bazon, 2002-2005  |  www.bazon.net/mishoo
 * -----------------------------------------------------------
 *
 * The DHTML Calendar, version 1.0 "It is happening again"
 *
 * Details and latest version at:
 * www.dynarch.com/projects/calendar
 *
 * This script is developed by Dynarch.com.  Visit us at www.dynarch.com.
 *
 * This script is distributed under the GNU Lesser General Public License.
 * Read the entire license text here: http://www.gnu.org/licenses/lgpl.html
 */

// $Id: calendar.js,v 1.51 2005/03/07 16:44:31 mishoo Exp $
//
// Modernized to ES6+ (strict mode, const/let, classList, addEventListener).
// Behaviour is intentionally preserved 1:1; the public surface stays global:
//   - window.Calendar (constructor + Calendar.setup) — invoked by the client
//     action dispatcher as window[service][method](args).
//   - window._dynarch_popupCalendar.
//   - Date.* patches (parseDate, prototype.print/equalsTo/...) — relied upon by
//     calendarcontrol.js, so they must remain global.

(function () {
	"use strict";

	/** The Calendar object constructor. */
	function Calendar(firstDayOfWeek, dateStr, onSelected, onClose) {
		// member variables
		this.activeDiv = null;
		this.currentDateEl = null;
		this.getDateStatus = null;
		this.getDateToolTip = null;
		this.getDateText = null;
		this.timeout = null;
		this.onSelected = onSelected || null;
		this.onClose = onClose || null;
		this.dragging = false;
		this.hidden = false;
		this.minYear = 1970;
		this.maxYear = 2050;
		this.dateFormat = Calendar._TT["DEF_DATE_FORMAT"];
		this.ttDateFormat = Calendar._TT["TT_DATE_FORMAT"];
		this.isPopup = true;
		this.weekNumbers = true;
		this.firstDayOfWeek = typeof firstDayOfWeek == "number" ? firstDayOfWeek : Calendar._FD; // 0 for Sunday, 1 for Monday, etc.
		this.showsOtherMonths = false;
		this.dateStr = dateStr;
		this.ar_days = null;
		this.showsTime = false;
		this.time24 = true;
		this.yearStep = 2;
		this.hiliteToday = true;
		this.multiple = null;
		// HTML elements
		this.table = null;
		this.element = null;
		this.tbody = null;
		this.firstdayname = null;
		// Combo boxes
		this.monthsCombo = null;
		this.yearsCombo = null;
		this.hilitedMonth = null;
		this.activeMonth = null;
		this.hilitedYear = null;
		this.activeYear = null;
		// Information
		this.dateClicked = false;

		// one-time initializations
		if (typeof Calendar._SDN == "undefined") {
			// table of short day names
			if (typeof Calendar._SDN_len == "undefined")
				Calendar._SDN_len = 3;
			let ar = [];
			for (let i = 8; i > 0;) {
				ar[--i] = Calendar._DN[i].substr(0, Calendar._SDN_len);
			}
			Calendar._SDN = ar;
			// table of short month names
			if (typeof Calendar._SMN_len == "undefined")
				Calendar._SMN_len = 3;
			ar = [];
			for (let i = 12; i > 0;) {
				ar[--i] = Calendar._MN[i].substr(0, Calendar._SMN_len);
			}
			Calendar._SMN = ar;
		}
	}

	// ** constants

	/// "static", needed for event handlers.
	Calendar._C = null;

	// BEGIN: UTILITY FUNCTIONS

	Calendar.getAbsolutePos = function (el) {
		// 20.01.2021 Fixed calendar positioning bug
		const rect = el.getBoundingClientRect();
		const win = el.ownerDocument.defaultView;
		return {
			y: rect.top + win.scrollY,
			x: rect.left + win.scrollX
		};
	};

	Calendar.isRelated = function (el, evt) {
		let related = evt.relatedTarget;
		while (related) {
			if (related == el) {
				return true;
			}
			related = related.parentNode;
		}
		return false;
	};

	Calendar.removeClass = function (el, className) {
		if (!(el && el.classList)) {
			return;
		}
		for (const cls of className.split(" ")) {
			if (cls) el.classList.remove(cls);
		}
	};

	Calendar.addClass = function (el, className) {
		if (!(el && el.classList)) {
			return;
		}
		for (const cls of className.split(" ")) {
			if (cls) el.classList.add(cls);
		}
	};

	Calendar.getElement = function (ev) {
		let f = ev.currentTarget;
		while (f.nodeType != 1 || /^div$/i.test(f.tagName))
			f = f.parentNode;
		return f;
	};

	Calendar.getTargetElement = function (ev) {
		let f = ev.target;
		while (f.nodeType != 1)
			f = f.parentNode;
		return f;
	};

	Calendar.stopEvent = function (ev) {
		ev.preventDefault();
		ev.stopPropagation();
		return false;
	};

	Calendar.addEvent = function (el, evname, func) {
		el.addEventListener(evname, func, true);
	};

	Calendar.removeEvent = function (el, evname, func) {
		el.removeEventListener(evname, func, true);
	};

	Calendar.createElement = function (type, parent) {
		const el = document.createElement(type);
		if (typeof parent != "undefined") {
			parent.appendChild(el);
		}
		return el;
	};

	// END: UTILITY FUNCTIONS

	// BEGIN: CALENDAR STATIC FUNCTIONS

	/** Internal -- adds a set of events to make some element behave like a button. */
	Calendar._add_evs = function (el) {
		Calendar.addEvent(el, "mouseover", Calendar.dayMouseOver);
		Calendar.addEvent(el, "mousedown", Calendar.dayMouseDown);
		Calendar.addEvent(el, "mouseout", Calendar.dayMouseOut);
	};

	Calendar.findMonth = function (el) {
		if (typeof el.month != "undefined") {
			return el;
		} else if (typeof el.parentNode.month != "undefined") {
			return el.parentNode;
		}
		return null;
	};

	Calendar.findYear = function (el) {
		if (typeof el.year != "undefined") {
			return el;
		} else if (typeof el.parentNode.year != "undefined") {
			return el.parentNode;
		}
		return null;
	};

	Calendar.showMonthsCombo = function () {
		const cal = Calendar._C;
		if (!cal) {
			return false;
		}
		const cd = cal.activeDiv;
		const mc = cal.monthsCombo;
		if (cal.hilitedMonth) {
			Calendar.removeClass(cal.hilitedMonth, "hilite");
		}
		if (cal.activeMonth) {
			Calendar.removeClass(cal.activeMonth, "active");
		}
		const mon = cal.monthsCombo.getElementsByTagName("div")[cal.date.getMonth()];
		Calendar.addClass(mon, "active");
		cal.activeMonth = mon;
		const s = mc.style;
		s.display = "block";
		if (cd.navtype < 0)
			s.left = cd.offsetLeft + "px";
		else {
			const mcw = mc.offsetWidth;
			s.left = (cd.offsetLeft + cd.offsetWidth - mcw) + "px";
		}
		s.top = (cd.offsetTop + cd.offsetHeight) + "px";
	};

	Calendar.showYearsCombo = function (fwd) {
		const cal = Calendar._C;
		if (!cal) {
			return false;
		}
		const cd = cal.activeDiv;
		const yc = cal.yearsCombo;
		if (cal.hilitedYear) {
			Calendar.removeClass(cal.hilitedYear, "hilite");
		}
		if (cal.activeYear) {
			Calendar.removeClass(cal.activeYear, "active");
		}
		cal.activeYear = null;
		let Y = cal.date.getFullYear() + (fwd ? 1 : -1);
		let yr = yc.firstChild;
		let show = false;
		for (let i = 12; i > 0; --i) {
			if (Y >= cal.minYear && Y <= cal.maxYear) {
				yr.innerHTML = Y;
				yr.year = Y;
				yr.style.display = "block";
				show = true;
			} else {
				yr.style.display = "none";
			}
			yr = yr.nextSibling;
			Y += fwd ? cal.yearStep : -cal.yearStep;
		}
		if (show) {
			const s = yc.style;
			s.display = "block";
			if (cd.navtype < 0)
				s.left = cd.offsetLeft + "px";
			else {
				const ycw = yc.offsetWidth;
				s.left = (cd.offsetLeft + cd.offsetWidth - ycw) + "px";
			}
			s.top = (cd.offsetTop + cd.offsetHeight) + "px";
		}
	};

	// event handlers

	Calendar.tableMouseUp = function (ev) {
		const cal = Calendar._C;
		if (!cal) {
			return false;
		}
		if (cal.timeout) {
			clearTimeout(cal.timeout);
		}
		const el = cal.activeDiv;
		if (!el) {
			return false;
		}
		const target = Calendar.getTargetElement(ev);
		Calendar.removeClass(el, "active");
		if (target == el || target.parentNode == el) {
			Calendar.cellClick(el, ev);
		}
		const mon = Calendar.findMonth(target);
		let date = null;
		if (mon) {
			date = new Date(cal.date);
			if (mon.month != date.getMonth()) {
				date.setMonth(mon.month);
				cal.setDate(date);
				cal.dateClicked = false;
				cal.callHandler();
			}
		} else {
			const year = Calendar.findYear(target);
			if (year) {
				date = new Date(cal.date);
				if (year.year != date.getFullYear()) {
					date.setFullYear(year.year);
					cal.setDate(date);
					cal.dateClicked = false;
					cal.callHandler();
				}
			}
		}
		Calendar.removeEvent(document, "mouseup", Calendar.tableMouseUp);
		Calendar.removeEvent(document, "mouseover", Calendar.tableMouseOver);
		Calendar.removeEvent(document, "mousemove", Calendar.tableMouseOver);
		cal._hideCombos();
		Calendar._C = null;
		return Calendar.stopEvent(ev);
	};

	Calendar.tableMouseOver = function (ev) {
		const cal = Calendar._C;
		if (!cal) {
			return;
		}
		const el = cal.activeDiv;
		const target = Calendar.getTargetElement(ev);
		if (target == el || target.parentNode == el) {
			Calendar.addClass(el, "hilite active");
			Calendar.addClass(el.parentNode, "rowhilite");
		} else {
			if (typeof el.navtype == "undefined" || (el.navtype != 50 && (el.navtype == 0 || Math.abs(el.navtype) > 2)))
				Calendar.removeClass(el, "active");
			Calendar.removeClass(el, "hilite");
			Calendar.removeClass(el.parentNode, "rowhilite");
		}
		if (el.navtype == 50 && target != el) {
			const pos = Calendar.getAbsolutePos(el);
			const w = el.offsetWidth;
			const x = ev.clientX;
			let dx;
			let decrease = true;
			if (x > pos.x + w) {
				dx = x - pos.x - w;
				decrease = false;
			} else
				dx = pos.x - x;

			if (dx < 0) dx = 0;
			const range = el._range;
			const current = el._current;
			let count = Math.floor(dx / 10) % range.length;
			let i;
			for (i = range.length; --i >= 0;)
				if (range[i] == current)
					break;
			while (count-- > 0)
				if (decrease) {
					if (--i < 0)
						i = range.length - 1;
				} else if (++i >= range.length)
					i = 0;
			const newval = range[i];
			el.innerHTML = newval;

			cal.onUpdateTime();
		}
		const mon = Calendar.findMonth(target);
		if (mon) {
			if (mon.month != cal.date.getMonth()) {
				if (cal.hilitedMonth) {
					Calendar.removeClass(cal.hilitedMonth, "hilite");
				}
				Calendar.addClass(mon, "hilite");
				cal.hilitedMonth = mon;
			} else if (cal.hilitedMonth) {
				Calendar.removeClass(cal.hilitedMonth, "hilite");
			}
		} else {
			if (cal.hilitedMonth) {
				Calendar.removeClass(cal.hilitedMonth, "hilite");
			}
			const year = Calendar.findYear(target);
			if (year) {
				if (year.year != cal.date.getFullYear()) {
					if (cal.hilitedYear) {
						Calendar.removeClass(cal.hilitedYear, "hilite");
					}
					Calendar.addClass(year, "hilite");
					cal.hilitedYear = year;
				} else if (cal.hilitedYear) {
					Calendar.removeClass(cal.hilitedYear, "hilite");
				}
			} else if (cal.hilitedYear) {
				Calendar.removeClass(cal.hilitedYear, "hilite");
			}
		}
		return Calendar.stopEvent(ev);
	};

	Calendar.tableMouseDown = function (ev) {
		if (Calendar.getTargetElement(ev) == Calendar.getElement(ev)) {
			return Calendar.stopEvent(ev);
		}
	};

	Calendar.calDragIt = function (ev) {
		const cal = Calendar._C;
		if (!(cal && cal.dragging)) {
			return false;
		}
		const posX = ev.pageX;
		const posY = ev.pageY;
		const st = cal.element.style;
		st.left = (posX - cal.xOffs) + "px";
		st.top = (posY - cal.yOffs) + "px";
		return Calendar.stopEvent(ev);
	};

	Calendar.calDragEnd = function (ev) {
		const cal = Calendar._C;
		if (!cal) {
			return false;
		}
		cal.dragging = false;
		Calendar.removeEvent(document, "mousemove", Calendar.calDragIt);
		Calendar.removeEvent(document, "mouseup", Calendar.calDragEnd);
		Calendar.tableMouseUp(ev);
	};

	Calendar.dayMouseDown = function (ev) {
		const el = Calendar.getElement(ev);
		if (el.disabled) {
			return false;
		}
		const cal = el.calendar;
		cal.activeDiv = el;
		Calendar._C = cal;
		if (el.navtype != 300) {
			if (el.navtype == 50) {
				el._current = el.innerHTML;
				Calendar.addEvent(document, "mousemove", Calendar.tableMouseOver);
			} else
				Calendar.addEvent(document, "mouseover", Calendar.tableMouseOver);
			Calendar.addClass(el, "hilite active");
			Calendar.addEvent(document, "mouseup", Calendar.tableMouseUp);
		} else if (cal.isPopup) {
			cal._dragStart(ev);
		}
		if (el.navtype == -1 || el.navtype == 1) {
			if (cal.timeout) clearTimeout(cal.timeout);
			cal.timeout = setTimeout(Calendar.showMonthsCombo, 250);
		} else if (el.navtype == -2 || el.navtype == 2) {
			if (cal.timeout) clearTimeout(cal.timeout);
			cal.timeout = setTimeout(() => Calendar.showYearsCombo(el.navtype > 0), 250);
		} else {
			cal.timeout = null;
		}
		return Calendar.stopEvent(ev);
	};

	Calendar.dayMouseDblClick = function (ev) {
		Calendar.cellClick(Calendar.getElement(ev), ev);
	};

	Calendar.dayMouseOver = function (ev) {
		const el = Calendar.getElement(ev);
		if (Calendar.isRelated(el, ev) || Calendar._C || el.disabled) {
			return false;
		}
		if (el.ttip) {
			if (el.ttip.substr(0, 1) == "_") {
				el.ttip = el.caldate.print(el.calendar.ttDateFormat) + el.ttip.substr(1);
			}
			el.calendar.tooltips.innerHTML = el.ttip;
		}
		if (el.navtype != 300) {
			Calendar.addClass(el, "hilite");
			if (el.caldate) {
				Calendar.addClass(el.parentNode, "rowhilite");
			}
		}
		return Calendar.stopEvent(ev);
	};

	Calendar.dayMouseOut = function (ev) {
		const el = Calendar.getElement(ev);
		if (Calendar.isRelated(el, ev) || Calendar._C || el.disabled)
			return false;
		Calendar.removeClass(el, "hilite");
		if (el.caldate)
			Calendar.removeClass(el.parentNode, "rowhilite");
		if (el.calendar)
			el.calendar.tooltips.innerHTML = Calendar._TT["SEL_DATE"];
		return Calendar.stopEvent(ev);
	};

	/**
	 *  A generic "click" handler :) handles all types of buttons defined in this
	 *  calendar.
	 */
	Calendar.cellClick = function (el, ev) {
		const cal = el.calendar;
		let closing = false;
		let newdate = false;
		let date = null;
		if (typeof el.navtype == "undefined") {
			if (cal.currentDateEl) {
				Calendar.removeClass(cal.currentDateEl, "selected");
				Calendar.addClass(el, "selected");
				closing = (cal.currentDateEl == el);
				if (!closing) {
					cal.currentDateEl = el;
				}
			}
			cal.date.setDateOnly(el.caldate);
			date = cal.date;
			const other_month = !(cal.dateClicked = !el.otherMonth);
			if (!other_month && !cal.currentDateEl)
				cal._toggleMultipleDate(new Date(date));
			else
				newdate = !el.disabled;
			// a date was clicked
			if (other_month)
				cal._init(cal.firstDayOfWeek, date);
		} else {
			if (el.navtype == 200) {
				Calendar.removeClass(el, "hilite");
				cal.callCloseHandler();
				return;
			}
			date = new Date(cal.date);
			if (el.navtype == 0)
				date.setDateOnly(new Date()); // TODAY
			// unless "today" was clicked, we assume no date was clicked so
			// the selected handler will know not to close the calenar when
			// in single-click mode.
			// cal.dateClicked = (el.navtype == 0);
			cal.dateClicked = false;
			let year = date.getFullYear();
			const mon = date.getMonth();
			const setMonth = (m) => {
				const day = date.getDate();
				const max = date.getMonthDays(m);
				if (day > max) {
					date.setDate(max);
				}
				date.setMonth(m);
			};
			switch (el.navtype) {
				case 400: {
					Calendar.removeClass(el, "hilite");
					let text = Calendar._TT["ABOUT"];
					if (typeof text != "undefined") {
						text += cal.showsTime ? Calendar._TT["ABOUT_TIME"] : "";
					} else {
						// FIXME: this should be removed as soon as lang files get updated!
						text = "Help and about box text is not translated into this language.\n" +
							"If you know this language and you feel generous please update\n" +
							"the corresponding file in \"lang\" subdir to match calendar-en.js\n" +
							"and send it back to <mihai_bazon@yahoo.com> to get it into the distribution  ;-)\n\n" +
							"Thank you!\n" +
							"http://dynarch.com/mishoo/calendar.epl\n";
					}
					alert(text);
					return;
				}
				case -2:
					if (year > cal.minYear) {
						date.setFullYear(year - 1);
					}
					break;
				case -1:
					if (mon > 0) {
						setMonth(mon - 1);
					} else if (year-- > cal.minYear) {
						date.setFullYear(year);
						setMonth(11);
					}
					break;
				case 1:
					if (mon < 11) {
						setMonth(mon + 1);
					} else if (year < cal.maxYear) {
						date.setFullYear(year + 1);
						setMonth(0);
					}
					break;
				case 2:
					if (year < cal.maxYear) {
						date.setFullYear(year + 1);
					}
					break;
				case 100:
					cal.setFirstDayOfWeek(el.fdow);
					return;
				case 50: {
					const range = el._range;
					const current = el.innerHTML;
					let i;
					for (i = range.length; --i >= 0;)
						if (range[i] == current)
							break;
					if (ev && ev.shiftKey) {
						if (--i < 0)
							i = range.length - 1;
					} else if (++i >= range.length)
						i = 0;
					const newval = range[i];
					el.innerHTML = newval;
					cal.onUpdateTime();
					return;
				}
				case 0:
					// TODAY will bring us here
					if ((typeof cal.getDateStatus == "function") &&
						cal.getDateStatus(date, date.getFullYear(), date.getMonth(), date.getDate())) {
						return false;
					}
					break;
			}
			if (!date.equalsTo(cal.date)) {
				cal.setDate(date);
				newdate = true;
			} else if (el.navtype == 0)
				newdate = closing = true;
		}
		if (newdate) {
			ev && cal.callHandler();
		}
		if (closing) {
			Calendar.removeClass(el, "hilite");
			ev && cal.callCloseHandler();
		}
	};

	// END: CALENDAR STATIC FUNCTIONS

	// BEGIN: CALENDAR OBJECT FUNCTIONS

	/**
	 *  This function creates the calendar inside the given parent.  If _par is
	 *  null than it creates a popup calendar inside the BODY element.  If _par is
	 *  an element, be it BODY, then it creates a non-popup calendar (still
	 *  hidden).  Some properties need to be set before calling this function.
	 */
	Calendar.prototype.create = function (_par) {
		let parent = null;
		if (!_par) {
			// default parent is the document body, in which case we create
			// a popup calendar.
			parent = document.body;
			this.isPopup = true;
		} else {
			parent = _par;
			this.isPopup = false;
		}
		this.date = this.dateStr ? new Date(this.dateStr) : new Date();

		const table = Calendar.createElement("table");
		this.table = table;
		table.cellSpacing = 0;
		table.cellPadding = 0;
		table.calendar = this;
		Calendar.addEvent(table, "mousedown", Calendar.tableMouseDown);

		let div = Calendar.createElement("div");
		this.element = div;
		div.className = "calendar";
		if (this.isPopup) {
			div.style.position = "absolute";
			div.style.display = "none";
			div.style.zIndex = 9999;
		}
		div.appendChild(table);

		const thead = Calendar.createElement("thead", table);
		let cell = null;
		let row = null;

		const cal = this;
		const hh = function (text, cs, navtype) {
			cell = Calendar.createElement("td", row);
			cell.colSpan = cs;
			cell.className = "cal-button";
			if (navtype != 0 && Math.abs(navtype) <= 2)
				cell.className += " cal-nav";
			Calendar._add_evs(cell);
			cell.calendar = cal;
			cell.navtype = navtype;
			cell.innerHTML = "<div>" + text + "</div>";
			return cell;
		};

		row = Calendar.createElement("tr", thead);
		let title_length = 6;
		(this.isPopup) && --title_length;
		(this.weekNumbers) && ++title_length;

		hh("?", 1, 400).ttip = Calendar._TT["INFO"];
		this.title = hh("", title_length, 300);
		this.title.className = "cal-title";
		if (this.isPopup) {
			this.title.ttip = Calendar._TT["DRAG_TO_MOVE"];
			this.title.style.cursor = "move";
			hh("&#x00d7;", 1, 200).ttip = Calendar._TT["CLOSE"];
		}

		row = Calendar.createElement("tr", thead);
		row.className = "headrow";

		this._nav_py = hh("&#x00ab;", 1, -2);
		this._nav_py.ttip = Calendar._TT["PREV_YEAR"];

		this._nav_pm = hh("&#x2039;", 1, -1);
		this._nav_pm.ttip = Calendar._TT["PREV_MONTH"];

		this._nav_now = hh(Calendar._TT["TODAY"], this.weekNumbers ? 4 : 3, 0);
		this._nav_now.ttip = Calendar._TT["GO_TODAY"];

		this._nav_nm = hh("&#x203a;", 1, 1);
		this._nav_nm.ttip = Calendar._TT["NEXT_MONTH"];

		this._nav_ny = hh("&#x00bb;", 1, 2);
		this._nav_ny.ttip = Calendar._TT["NEXT_YEAR"];

		// day names
		row = Calendar.createElement("tr", thead);
		row.className = "daynames";
		if (this.weekNumbers) {
			cell = Calendar.createElement("td", row);
			cell.className = "name wn";
			cell.innerHTML = Calendar._TT["WK"];
		}
		for (let i = 7; i > 0; --i) {
			cell = Calendar.createElement("td", row);
			if (!i) {
				cell.navtype = 100;
				cell.calendar = this;
				Calendar._add_evs(cell);
			}
		}
		this.firstdayname = (this.weekNumbers) ? row.firstChild.nextSibling : row.firstChild;
		this._displayWeekdays();

		const tbody = Calendar.createElement("tbody", table);
		this.tbody = tbody;

		for (let i = 6; i > 0; --i) {
			row = Calendar.createElement("tr", tbody);
			if (this.weekNumbers) {
				cell = Calendar.createElement("td", row);
			}
			for (let j = 7; j > 0; --j) {
				cell = Calendar.createElement("td", row);
				cell.calendar = this;
				Calendar._add_evs(cell);
			}
		}

		if (this.showsTime) {
			row = Calendar.createElement("tr", tbody);
			row.className = "time";

			cell = Calendar.createElement("td", row);
			cell.className = "time";
			cell.colSpan = 2;
			cell.innerHTML = Calendar._TT["TIME"] || "&nbsp;";

			cell = Calendar.createElement("td", row);
			cell.className = "time";
			cell.colSpan = this.weekNumbers ? 4 : 3;

			(function () {
				function makeTimePart(className, init, range_start, range_end) {
					const part = Calendar.createElement("span", cell);
					part.className = className;
					part.innerHTML = init;
					part.calendar = cal;
					part.ttip = Calendar._TT["TIME_PART"];
					part.navtype = 50;
					part._range = [];
					if (typeof range_start != "number")
						part._range = range_start;
					else {
						for (let i = range_start; i <= range_end; ++i) {
							let txt;
							if (i < 10 && range_end >= 10) txt = '0' + i;
							else txt = '' + i;
							part._range[part._range.length] = txt;
						}
					}
					Calendar._add_evs(part);
					return part;
				}
				let hrs = cal.date.getHours();
				const mins = cal.date.getMinutes();
				const t12 = !cal.time24;
				const pm = (hrs > 12);
				if (t12 && pm) hrs -= 12;
				const H = makeTimePart("hour", hrs, t12 ? 1 : 0, t12 ? 12 : 23);
				const span = Calendar.createElement("span", cell);
				span.innerHTML = ":";
				span.className = "colon";
				const M = makeTimePart("minute", mins, 0, 59);
				let AP = null;
				cell = Calendar.createElement("td", row);
				cell.className = "time";
				cell.colSpan = 2;
				if (t12)
					AP = makeTimePart("ampm", pm ? "pm" : "am", ["am", "pm"]);
				else
					cell.innerHTML = "&nbsp;";

				cal.onSetTime = function () {
					let pm, hrs = this.date.getHours();
					const mins = this.date.getMinutes();
					if (t12) {
						pm = (hrs >= 12);
						if (pm) hrs -= 12;
						if (hrs == 0) hrs = 12;
						AP.innerHTML = pm ? "pm" : "am";
					}
					H.innerHTML = (hrs < 10) ? ("0" + hrs) : hrs;
					M.innerHTML = (mins < 10) ? ("0" + mins) : mins;
				};

				cal.onUpdateTime = function () {
					const date = this.date;
					let h = parseInt(H.innerHTML, 10);
					if (t12) {
						if (/pm/i.test(AP.innerHTML) && h < 12)
							h += 12;
						else if (/am/i.test(AP.innerHTML) && h == 12)
							h = 0;
					}
					const d = date.getDate();
					const m = date.getMonth();
					const y = date.getFullYear();
					date.setHours(h);
					date.setMinutes(parseInt(M.innerHTML, 10));
					date.setFullYear(y);
					date.setMonth(m);
					date.setDate(d);
					this.dateClicked = false;
					this.callHandler();
				};
			})();
		} else {
			this.onSetTime = this.onUpdateTime = function () { };
		}

		const tfoot = Calendar.createElement("tfoot", table);

		row = Calendar.createElement("tr", tfoot);
		row.className = "footrow";

		cell = hh(Calendar._TT["SEL_DATE"], this.weekNumbers ? 8 : 7, 300);
		cell.className = "ttip";
		if (this.isPopup) {
			cell.ttip = Calendar._TT["DRAG_TO_MOVE"];
			cell.style.cursor = "move";
		}
		this.tooltips = cell;

		div = Calendar.createElement("div", this.element);
		this.monthsCombo = div;
		div.className = "cal-combo";
		for (let i = 0; i < Calendar._MN.length; ++i) {
			const mn = Calendar.createElement("div");
			mn.className = "cal-label";
			mn.month = i;
			mn.innerHTML = Calendar._SMN[i];
			div.appendChild(mn);
		}

		div = Calendar.createElement("div", this.element);
		this.yearsCombo = div;
		div.className = "cal-combo";
		for (let i = 12; i > 0; --i) {
			const yr = Calendar.createElement("div");
			yr.className = "cal-label";
			div.appendChild(yr);
		}

		this._init(this.firstDayOfWeek, this.date);
		parent.appendChild(this.element);
	};

	/** keyboard navigation, only for popup calendars */
	Calendar._keyEvent = function (ev) {
		const cal = window._dynarch_popupCalendar;
		if (!cal || cal.multiple)
			return false;

		const act = (ev.type == "keypress");
		let K = ev.keyCode;
		if (ev.ctrlKey) {
			switch (K) {
				case 37: // KEY left
					act && Calendar.cellClick(cal._nav_pm);
					break;
				case 38: // KEY up
					act && Calendar.cellClick(cal._nav_py);
					break;
				case 39: // KEY right
					act && Calendar.cellClick(cal._nav_nm);
					break;
				case 40: // KEY down
					act && Calendar.cellClick(cal._nav_ny);
					break;
				default:
					return false;
			}
		} else switch (K) {
			case 32: // KEY space (now)
				Calendar.cellClick(cal._nav_now);
				break;
			case 27: // KEY esc
				act && cal.callCloseHandler();
				break;
			case 37: // KEY left
			case 38: // KEY up
			case 39: // KEY right
			case 40: // KEY down
				if (act) {
					let x, y, ne, el;
					const prev = K == 37 || K == 38;
					const step = (K == 37 || K == 39) ? 1 : 7;
					const setVars = () => {
						el = cal.currentDateEl;
						const p = el.pos;
						x = p & 15;
						y = p >> 4;
						ne = cal.ar_days[y][x];
					};
					setVars();
					const prevMonth = () => {
						const date = new Date(cal.date);
						date.setDate(date.getDate() - step);
						cal.setDate(date);
					};
					const nextMonth = () => {
						const date = new Date(cal.date);
						date.setDate(date.getDate() + step);
						cal.setDate(date);
					};
					while (true) {
						switch (K) {
							case 37: // KEY left
								if (--x >= 0)
									ne = cal.ar_days[y][x];
								else {
									x = 6;
									K = 38;
									continue;
								}
								break;
							case 38: // KEY up
								if (--y >= 0)
									ne = cal.ar_days[y][x];
								else {
									prevMonth();
									setVars();
								}
								break;
							case 39: // KEY right
								if (++x < 7)
									ne = cal.ar_days[y][x];
								else {
									x = 0;
									K = 40;
									continue;
								}
								break;
							case 40: // KEY down
								if (++y < cal.ar_days.length)
									ne = cal.ar_days[y][x];
								else {
									nextMonth();
									setVars();
								}
								break;
						}
						break;
					}
					if (ne) {
						if (!ne.disabled)
							Calendar.cellClick(ne);
						else if (prev)
							prevMonth();
						else
							nextMonth();
					}
				}
				break;
			case 13: // KEY enter
				if (act)
					Calendar.cellClick(cal.currentDateEl, ev);
				break;
			default:
				return false;
		}
		return Calendar.stopEvent(ev);
	};

	/**
	 *  (RE)Initializes the calendar to the given date and firstDayOfWeek
	 */
	Calendar.prototype._init = function (firstDayOfWeek, date) {
		const today = new Date(),
			TY = today.getFullYear(),
			TM = today.getMonth(),
			TD = today.getDate();
		this.table.style.visibility = "hidden";
		let year = date.getFullYear();
		if (year < this.minYear) {
			year = this.minYear;
			date.setFullYear(year);
		} else if (year > this.maxYear) {
			year = this.maxYear;
			date.setFullYear(year);
		}
		this.firstDayOfWeek = firstDayOfWeek;
		this.date = new Date(date);
		const month = date.getMonth();
		const mday = date.getDate();
		const no_days = date.getMonthDays();

		// calendar voodoo for computing the first day that would actually be
		// displayed in the calendar, even if it's from the previous month.
		// WARNING: this is magic. ;-)
		date.setDate(1);
		let day1 = (date.getDay() - this.firstDayOfWeek) % 7;
		if (day1 < 0)
			day1 += 7;
		date.setDate(-day1);
		date.setDate(date.getDate() + 1);

		let row = this.tbody.firstChild;
		const MN = Calendar._SMN[month];
		const ar_days = this.ar_days = [];
		const weekend = Calendar._TT["WEEKEND"];
		const dates = this.multiple ? (this.datesCells = {}) : null;
		for (let i = 0; i < 6; ++i, row = row.nextSibling) {
			let cell = row.firstChild;
			if (this.weekNumbers) {
				cell.className = "day wn";
				cell.innerHTML = date.getWeekNumber();
				cell = cell.nextSibling;
			}
			row.className = "daysrow";
			let hasdays = false, iday;
			const dpos = ar_days[i] = [];
			for (let j = 0; j < 7; ++j, cell = cell.nextSibling, date.setDate(iday + 1)) {
				iday = date.getDate();
				const wday = date.getDay();
				cell.className = "day";
				cell.pos = i << 4 | j;
				dpos[j] = cell;
				const current_month = (date.getMonth() == month);
				if (!current_month) {
					if (this.showsOtherMonths) {
						cell.className += " othermonth";
						cell.otherMonth = true;
					} else {
						cell.className = "emptycell";
						cell.innerHTML = "&nbsp;";
						cell.disabled = true;
						continue;
					}
				} else {
					cell.otherMonth = false;
					hasdays = true;
				}
				cell.disabled = false;
				cell.innerHTML = this.getDateText ? this.getDateText(date, iday) : iday;
				if (dates)
					dates[date.print("%Y%m%d")] = cell;
				if (this.getDateStatus) {
					const status = this.getDateStatus(date, year, month, iday);
					if (this.getDateToolTip) {
						const toolTip = this.getDateToolTip(date, year, month, iday);
						if (toolTip)
							cell.title = toolTip;
					}
					if (status === true) {
						cell.className += " disabled";
						cell.disabled = true;
					} else {
						if (/disabled/i.test(status))
							cell.disabled = true;
						cell.className += " " + status;
					}
				}
				if (!cell.disabled) {
					cell.caldate = new Date(date);
					cell.ttip = "_";
					if (!this.multiple && current_month
					    && iday == mday && this.hiliteToday) {
						cell.className += " selected";
						this.currentDateEl = cell;
					}
					if (date.getFullYear() == TY &&
					    date.getMonth() == TM &&
					    iday == TD) {
						cell.className += " today";
						cell.ttip += Calendar._TT["PART_TODAY"];
					}
					if (weekend.indexOf(wday.toString()) != -1)
						cell.className += cell.otherMonth ? " oweekend" : " weekend";
				}
			}
			if (!(hasdays || this.showsOtherMonths))
				row.className = "emptyrow";
		}
		this.title.innerHTML = Calendar._MN[month] + ", " + year;
		this.onSetTime();
		this.table.style.visibility = "visible";
		this._initMultipleDates();
		// PROFILE
		// this.tooltips.innerHTML = "Generated in " + ((new Date()) - today) + " ms";
	};

	Calendar.prototype._initMultipleDates = function () {
		if (this.multiple) {
			for (const i in this.multiple) {
				const cell = this.datesCells[i];
				const d = this.multiple[i];
				if (!d)
					continue;
				if (cell)
					cell.className += " selected";
			}
		}
	};

	Calendar.prototype._toggleMultipleDate = function (date) {
		if (this.multiple) {
			const ds = date.print("%Y%m%d");
			const cell = this.datesCells[ds];
			if (cell) {
				const d = this.multiple[ds];
				if (!d) {
					Calendar.addClass(cell, "selected");
					this.multiple[ds] = date;
				} else {
					Calendar.removeClass(cell, "selected");
					delete this.multiple[ds];
				}
			}
		}
	};

	Calendar.prototype.setDateToolTipHandler = function (unaryFunction) {
		this.getDateToolTip = unaryFunction;
	};

	/**
	 *  Calls _init function above for going to a certain date (but only if the
	 *  date is different than the currently selected one).
	 */
	Calendar.prototype.setDate = function (date) {
		if (!date.equalsTo(this.date)) {
			this._init(this.firstDayOfWeek, date);
		}
	};

	/**
	 *  Refreshes the calendar.  Useful if the "disabledHandler" function is
	 *  dynamic, meaning that the list of disabled date can change at runtime.
	 *  Just * call this function if you think that the list of disabled dates
	 *  should * change.
	 */
	Calendar.prototype.refresh = function () {
		this._init(this.firstDayOfWeek, this.date);
	};

	/** Modifies the "firstDayOfWeek" parameter (pass 0 for Synday, 1 for Monday, etc.). */
	Calendar.prototype.setFirstDayOfWeek = function (firstDayOfWeek) {
		this._init(firstDayOfWeek, this.date);
		this._displayWeekdays();
	};

	/**
	 *  Allows customization of what dates are enabled.  The "unaryFunction"
	 *  parameter must be a function object that receives the date (as a JS Date
	 *  object) and returns a boolean value.  If the returned value is true then
	 *  the passed date will be marked as disabled.
	 */
	Calendar.prototype.setDateStatusHandler = Calendar.prototype.setDisabledHandler = function (unaryFunction) {
		this.getDateStatus = unaryFunction;
	};

	/** Customization of allowed year range for the calendar. */
	Calendar.prototype.setRange = function (a, z) {
		this.minYear = a;
		this.maxYear = z;
	};

	/** Calls the first user handler (selectedHandler). */
	Calendar.prototype.callHandler = function () {
		if (this.onSelected) {
			this.onSelected(this, this.date.print(this.dateFormat));
		}
	};

	/** Calls the second user handler (closeHandler). */
	Calendar.prototype.callCloseHandler = function () {
		if (this.onClose) {
			this.onClose(this);
		}
	};

	/** Removes the calendar object from the DOM tree and destroys it. */
	Calendar.prototype.destroy = function () {
		const el = this.element.parentNode;
		el.removeChild(this.element);
		Calendar._C = null;
		window._dynarch_popupCalendar = null;
	};

	/**
	 *  Moves the calendar element to a different section in the DOM tree (changes
	 *  its parent).
	 */
	Calendar.prototype.reparent = function (new_parent) {
		const el = this.element;
		el.parentNode.removeChild(el);
		new_parent.appendChild(el);
	};

	// This gets called when the user presses a mouse button anywhere in the
	// document, if the calendar is shown.  If the click was outside the open
	// calendar this function closes it.
	Calendar._checkCalendar = function (ev) {
		const calendar = window._dynarch_popupCalendar;
		if (!calendar) {
			return false;
		}
		let el = Calendar.getTargetElement(ev);
		for (; el != null && el != calendar.element; el = el.parentNode);
		if (el == null) {
			// calls closeHandler which should hide the calendar.
			window._dynarch_popupCalendar.callCloseHandler();
			return Calendar.stopEvent(ev);
		}
	};

	/** Shows the calendar. */
	Calendar.prototype.show = function () {
		const rows = this.table.getElementsByTagName("tr");
		for (let i = rows.length; i > 0;) {
			const row = rows[--i];
			Calendar.removeClass(row, "rowhilite");
			const cells = row.getElementsByTagName("td");
			for (let j = cells.length; j > 0;) {
				const cell = cells[--j];
				Calendar.removeClass(cell, "hilite");
				Calendar.removeClass(cell, "active");
			}
		}
		this.element.style.display = "block";
		this.hidden = false;
		if (this.isPopup) {
			window._dynarch_popupCalendar = this;
			Calendar.addEvent(document, "keydown", Calendar._keyEvent);
			Calendar.addEvent(document, "keypress", Calendar._keyEvent);
			Calendar.addEvent(document, "mousedown", Calendar._checkCalendar);
		}
	};

	/**
	 *  Hides the calendar.  Also removes any "hilite" from the class of any TD
	 *  element.
	 */
	Calendar.prototype.hide = function () {
		if (this.isPopup) {
			Calendar.removeEvent(document, "keydown", Calendar._keyEvent);
			Calendar.removeEvent(document, "keypress", Calendar._keyEvent);
			Calendar.removeEvent(document, "mousedown", Calendar._checkCalendar);
		}
		this.element.style.display = "none";
		this.hidden = true;
	};

	/**
	 *  Shows the calendar at a given absolute position (beware that, depending on
	 *  the calendar element style -- position property -- this might be relative
	 *  to the parent's containing rectangle).
	 */
	Calendar.prototype.showAt = function (x, y) {
		const s = this.element.style;
		s.left = x + "px";
		s.top = y + "px";
		this.show();
	};

	/** Shows the calendar near a given element. */
	Calendar.prototype.showAtElement = function (el, opts) {
		const self = this;
		const p = Calendar.getAbsolutePos(el);
		if (!opts || typeof opts != "string") {
			this.showAt(p.x, p.y + el.offsetHeight);
			return true;
		}

		this.element.style.display = "block";

		const w = self.element.offsetWidth;
		const h = self.element.offsetHeight;
		self.element.style.display = "none";
		const valign = opts.substr(0, 1);
		let halign = "l";
		if (opts.length > 1) {
			halign = opts.substr(1, 1);
		}
		// vertical alignment
		switch (valign) {
			case "T": p.y -= h; break;
			case "B": p.y += el.offsetHeight; break;
			case "C": p.y += (el.offsetHeight - h) / 2; break;
			case "t": p.y += el.offsetHeight - h; break;
			case "b": break; // already there
		}
		// horizontal alignment
		switch (halign) {
			case "L": p.x -= w; break;
			case "R": p.x += el.offsetWidth; break;
			case "C": p.x += (el.offsetWidth - w) / 2; break;
			case "l": p.x += el.offsetWidth - w; break;
			case "r": break; // already there
		}
		if (p.y + h > window.innerHeight)
			p.y -= h + el.offsetHeight;
		p.width = w;
		p.height = h + 40;
		self.monthsCombo.style.display = "none";
		self.showAt(p.x, p.y);
	};

	/** Customizes the date format. */
	Calendar.prototype.setDateFormat = function (str) {
		this.dateFormat = str;
	};

	/** Customizes the tooltip date format. */
	Calendar.prototype.setTtDateFormat = function (str) {
		this.ttDateFormat = str;
	};

	/**
	 *  Tries to identify the date represented in a string.  If successful it also
	 *  calls this.setDate which moves the calendar to the given date.
	 */
	Calendar.prototype.parseDate = function (str, fmt) {
		if (!fmt)
			fmt = this.dateFormat;
		this.setDate(Date.parseDate(str, fmt));
	};

	/** Internal function; it displays the bar with the names of the weekday. */
	Calendar.prototype._displayWeekdays = function () {
		const fdow = this.firstDayOfWeek;
		let cell = this.firstdayname;
		const weekend = Calendar._TT["WEEKEND"];
		for (let i = 0; i < 7; ++i) {
			cell.className = "day name";
			const realday = (i + fdow) % 7;
			if (i) {
				cell.ttip = Calendar._TT["DAY_FIRST"].replace("%s", Calendar._DN[realday]);
				cell.navtype = 100;
				cell.calendar = this;
				cell.fdow = realday;
				Calendar._add_evs(cell);
			}
			if (weekend.indexOf(realday.toString()) != -1) {
				Calendar.addClass(cell, "weekend");
			}
			cell.innerHTML = Calendar._SDN[(i + fdow) % 7];
			cell = cell.nextSibling;
		}
	};

	/** Internal function.  Hides all combo boxes that might be displayed. */
	Calendar.prototype._hideCombos = function () {
		this.monthsCombo.style.display = "none";
		this.yearsCombo.style.display = "none";
	};

	/** Internal function.  Starts dragging the element. */
	Calendar.prototype._dragStart = function (ev) {
		if (this.dragging) {
			return;
		}
		this.dragging = true;
		const posY = ev.clientY + window.scrollY;
		const posX = ev.clientX + window.scrollX;
		const st = this.element.style;
		this.xOffs = posX - parseInt(st.left);
		this.yOffs = posY - parseInt(st.top);
		Calendar.addEvent(document, "mousemove", Calendar.calDragIt);
		Calendar.addEvent(document, "mouseup", Calendar.calDragEnd);
	};

	// BEGIN: DATE OBJECT PATCHES

	/** Adds the number of days array to the Date object. */
	Date._MD = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

	/** Constants used for time computations */
	Date.SECOND = 1000 /* milliseconds */;
	Date.MINUTE = 60 * Date.SECOND;
	Date.HOUR = 60 * Date.MINUTE;
	Date.DAY = 24 * Date.HOUR;
	Date.WEEK = 7 * Date.DAY;

	Date.parseDate = function (str, fmt) {
		let y = 0;
		let m = -1;
		let d = 0;
		const a = str.split(/\W+/);
		const b = fmt.match(/%./g);
		let i = 0, j = 0;
		let hr = 0;
		let min = 0;
		for (i = 0; i < a.length; ++i) {
			if (!a[i])
				continue;
			switch (b[i]) {
				case "%d":
				case "%e":
					d = parseInt(a[i], 10);
					break;

				case "%m":
					m = parseInt(a[i], 10) - 1;
					break;

				case "%Y":
				case "%y":
					y = parseInt(a[i], 10);
					(y < 100) && (y += (y > 29) ? 1900 : 2000);
					break;

				case "%b":
				case "%B":
					for (j = 0; j < 12; ++j) {
						if (Calendar._MN[j].substr(0, a[i].length).toLowerCase() == a[i].toLowerCase()) { m = j; break; }
					}
					break;

				case "%H":
				case "%I":
				case "%k":
				case "%l":
					hr = parseInt(a[i], 10);
					break;

				case "%P":
				case "%p":
					if (/pm/i.test(a[i]) && hr < 12)
						hr += 12;
					else if (/am/i.test(a[i]) && hr >= 12)
						hr -= 12;
					break;

				case "%M":
					min = parseInt(a[i], 10);
					break;
			}
		}
		if (y != 0 && m != -1 && d != 0)
			return new Date(y, m, d, hr, min, 0);
		return null;
	};

	/** Returns the number of days in the current month */
	Date.prototype.getMonthDays = function (month) {
		const year = this.getFullYear();
		if (typeof month == "undefined") {
			month = this.getMonth();
		}
		if (((0 == (year % 4)) && ((0 != (year % 100)) || (0 == (year % 400)))) && month == 1) {
			return 29;
		} else {
			return Date._MD[month];
		}
	};

	/** Returns the number of day in the year. */
	Date.prototype.getDayOfYear = function () {
		const now = new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0);
		const then = new Date(this.getFullYear(), 0, 0, 0, 0, 0);
		const time = now - then;
		return Math.floor(time / Date.DAY);
	};

	/** Returns the number of the week in year, as defined in ISO 8601. */
	Date.prototype.getWeekNumber = function () {
		const d = new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0);
		const DoW = d.getDay();
		d.setDate(d.getDate() - (DoW + 6) % 7 + 3); // Nearest Thu
		const ms = d.valueOf(); // GMT
		d.setMonth(0);
		d.setDate(4); // Thu in Week 1
		return Math.round((ms - d.valueOf()) / (7 * 864e5)) + 1;
	};

	/** Checks date and time equality */
	Date.prototype.equalsTo = function (date) {
		return ((this.getFullYear() == date.getFullYear()) &&
			(this.getMonth() == date.getMonth()) &&
			(this.getDate() == date.getDate()) &&
			(this.getHours() == date.getHours()) &&
			(this.getMinutes() == date.getMinutes()));
	};

	/** Set only the year, month, date parts (keep existing time) */
	Date.prototype.setDateOnly = function (date) {
		const tmp = new Date(date);
		this.setDate(1);
		this.setFullYear(tmp.getFullYear());
		this.setMonth(tmp.getMonth());
		this.setDate(tmp.getDate());
	};

	/** Prints the date in a string according to the given format. */
	Date.prototype.print = function (str) {
		const m = this.getMonth();
		const d = this.getDate();
		const y = this.getFullYear();
		const wn = this.getWeekNumber();
		const w = this.getDay();
		const s = {};
		const hr = this.getHours();
		const pm = (hr >= 12);
		let ir = (pm) ? (hr - 12) : hr;
		const dy = this.getDayOfYear();
		if (ir == 0)
			ir = 12;
		const min = this.getMinutes();
		const sec = this.getSeconds();
		s["%a"] = Calendar._SDN[w]; // abbreviated weekday name [FIXME: I18N]
		s["%A"] = Calendar._DN[w]; // full weekday name
		s["%b"] = Calendar._SMN[m]; // abbreviated month name [FIXME: I18N]
		s["%B"] = Calendar._MN[m]; // full month name
		// FIXME: %c : preferred date and time representation for the current locale
		s["%C"] = 1 + Math.floor(y / 100); // the century number
		s["%d"] = (d < 10) ? ("0" + d) : d; // the day of the month (range 01 to 31)
		s["%e"] = d; // the day of the month (range 1 to 31)
		// FIXME: %D : american date style: %m/%d/%y
		// FIXME: %E, %F, %G, %g, %h (man strftime)
		s["%H"] = (hr < 10) ? ("0" + hr) : hr; // hour, range 00 to 23 (24h format)
		s["%I"] = (ir < 10) ? ("0" + ir) : ir; // hour, range 01 to 12 (12h format)
		s["%j"] = (dy < 100) ? ((dy < 10) ? ("00" + dy) : ("0" + dy)) : dy; // day of the year (range 001 to 366)
		s["%k"] = hr;		// hour, range 0 to 23 (24h format)
		s["%l"] = ir;		// hour, range 1 to 12 (12h format)
		s["%m"] = (m < 9) ? ("0" + (1 + m)) : (1 + m); // month, range 01 to 12
		s["%M"] = (min < 10) ? ("0" + min) : min; // minute, range 00 to 59
		s["%n"] = "\n";		// a newline character
		s["%p"] = pm ? "PM" : "AM";
		s["%P"] = pm ? "pm" : "am";
		// FIXME: %r : the time in am/pm notation %I:%M:%S %p
		// FIXME: %R : the time in 24-hour notation %H:%M
		s["%s"] = Math.floor(this.getTime() / 1000);
		s["%S"] = (sec < 10) ? ("0" + sec) : sec; // seconds, range 00 to 59
		s["%t"] = "\t";		// a tab character
		// FIXME: %T : the time in 24-hour notation (%H:%M:%S)
		s["%U"] = s["%W"] = s["%V"] = (wn < 10) ? ("0" + wn) : wn;
		s["%u"] = w + 1;	// the day of the week (range 1 to 7, 1 = MON)
		s["%w"] = w;		// the day of the week (range 0 to 6, 0 = SUN)
		// FIXME: %x : preferred date representation for the current locale without the time
		// FIXME: %X : preferred time representation for the current locale without the date
		s["%y"] = ('' + y).substr(2, 2); // year without the century (range 00 to 99)
		s["%Y"] = y;		// year with the century
		s["%%"] = "%";		// a literal '%' character

		const re = /%./g;
		return str.replace(re, function (par) { return s[par] || par; });
	};

	Date.prototype.__msh_oldSetFullYear = Date.prototype.setFullYear;
	Date.prototype.setFullYear = function (y) {
		const d = new Date(this);
		d.__msh_oldSetFullYear(y);
		if (d.getMonth() != this.getMonth())
			this.setDate(28);
		this.__msh_oldSetFullYear(y);
	};

	// END: DATE OBJECT PATCHES

	Calendar.setup = function (params) {
		function param_default(pname, def) {
			if (typeof params[pname] == "undefined") {
				params[pname] = def;
			}
		}

		function dateStatusHandler(date, year, month, iday) {

			let finalDateStatus = false;

			if (params.disabledPeriod) {

				const startDate = new Date(params.disabledPeriod[0].item1);
				const finishDate = new Date(params.disabledPeriod[0].item2);

				if (startDate < date && finishDate > date)
					finalDateStatus = false;
				else
					finalDateStatus = "disabled disabledday";
			}

			if (params.disabledDates) {

				for (let i = 0; i < params.disabledDates.length; i++) {

					const disableDay = new Date(params.disabledDates[i]);

					if (date.getFullYear() == disableDay.getFullYear() &&
						date.getMonth() == disableDay.getMonth() &&
						date.getDate() == disableDay.getDate())

						finalDateStatus = "disabled disabledday";
				}
				finalDateStatus = false; // enable other dates
			}

			if (!params.disabledPeriod && !params.disabledDates) {
				finalDateStatus = false;
			}


			return finalDateStatus;

		}

		function onSelect(cal) {
			const p = cal.params;
			const update = (cal.dateClicked || p.electric);
			if (update && p.inputField) {
				p.inputField.value = cal.date.print(p.ifFormat);
				p.inputField.dispatchEvent(new Event("change", { bubbles: false, cancelable: true }));
			}
			if (update && p.displayArea) p.displayArea.innerHTML = cal.date.print(p.daFormat);
			if (update && typeof p.onUpdate == "function") p.onUpdate(cal);
			if (update && p.flat) {
				if (typeof p.flatCallback == "function") p.flatCallback(cal);
			}
			if (update && p.singleClick && cal.dateClicked) cal.callCloseHandler();
		}

		param_default("inputField", null);
		param_default("displayArea", null);
		param_default("button", null);
		param_default("eventName", "click");
		param_default("ifFormat", "%Y/%m/%d");
		param_default("daFormat", "%Y/%m/%d");
		param_default("singleClick", true);
		param_default("disableFunc", null);
		param_default("dateStatusFunc", dateStatusHandler);
		param_default("dateText", null);
		param_default("firstDay", null);
		param_default("align", "Br");
		param_default("range", [1900, 2999]);
		param_default("weekNumbers", true);
		param_default("flat", null);
		param_default("flatCallback", null);
		param_default("onSelect", null);
		param_default("onClose", null);
		param_default("onUpdate", null);
		param_default("date", null);
		param_default("showsTime", false);
		param_default("timeFormat", "24");
		param_default("electric", true);
		param_default("step", 2);
		param_default("position", null);
		param_default("cache", true);
		param_default("showOthers", false);
		param_default("multiple", null);
		param_default("disabledPeriod", []);
		param_default("disabledDates", []);
		const tmp = ["inputField", "displayArea", "button"];
		for (const name of tmp) {
			if (typeof params[name] == "string") {
				params[name] = document.getElementById(params[name]);
			}
		}
		if (!(params.flat || params.multiple || params.inputField || params.displayArea || params.button)) {
			alert("Calendar.setup:\n  Nothing to setup (no fields found).  Please check your code");
			return false;
		}

		let cal;
		if (params.flat != null) {
			if (typeof params.flat == "string") params.flat = document.getElementById(params.flat);
			if (!params.flat) {
				alert("Calendar.setup:\n  Flat specified but can't find parent.");
				return false;
			}
			cal = new Calendar(params.firstDay, params.date, params.onSelect || onSelect);
			cal.showsOtherMonths = params.showOthers;
			cal.showsTime = params.showsTime;
			cal.time24 = (params.timeFormat == "24");
			cal.params = params;
			cal.weekNumbers = params.weekNumbers;
			cal.setRange(params.range[0], params.range[1]);
			cal.setDateStatusHandler(params.dateStatusFunc);
			cal.getDateText = params.dateText;
			if (params.ifFormat) {
				cal.setDateFormat(params.ifFormat);
			}
			if (params.inputField && typeof params.inputField.value == "string") {
				cal.parseDate(params.inputField.value);
			}
			cal.create(params.flat);
			cal.show();
			return false;
		}
		const triggerEl = params.button || params.displayArea || params.inputField;
		triggerEl["on" + params.eventName] = function () {
			const dateEl = params.inputField || params.displayArea;
			const dateFmt = params.inputField ? params.ifFormat : params.daFormat;
			let mustCreate = false;
			let cal = window.calendar;
			if (dateEl) params.date = Date.parseDate(dateEl.value || dateEl.innerHTML, dateFmt);
			if (!(cal && params.cache)) {
				window.calendar = cal = new Calendar(params.firstDay, params.date, params.onSelect || onSelect, params.onClose || function (cal) {
					cal.hide();
				});
				cal.showsTime = params.showsTime;
				cal.time24 = (params.timeFormat == "24");
				cal.weekNumbers = params.weekNumbers;
				mustCreate = true;
			} else {
				if (params.date) cal.setDate(params.date);
				cal.hide();
			}
			if (params.multiple) {
				cal.multiple = {};
				for (let i = params.multiple.length; --i >= 0;) {
					const d = params.multiple[i];
					const ds = d.print("%Y%m%d");
					cal.multiple[ds] = d;
				}
			}
			cal.showsOtherMonths = params.showOthers;
			cal.yearStep = params.step;
			cal.setRange(params.range[0], params.range[1]);
			cal.params = params;
			cal.setDateStatusHandler(params.dateStatusFunc);
			cal.getDateText = params.dateText;
			cal.setDateFormat(dateFmt);
			if (mustCreate) cal.create();
			cal.refresh();
			if (!params.position) cal.showAtElement(params.button || params.displayArea || params.inputField, params.align);
			else cal.showAt(params.position[0], params.position[1]);
			return false;
		};
		return cal;
	};

	// Expose the public surface globally (the client action dispatcher resolves
	// services as window[service], and the lang files assign Calendar._DN etc.).
	window.Calendar = Calendar;
	// global object that remembers the calendar
	window._dynarch_popupCalendar = null;
})();
